// this file is also used by gatsby-node.js which has not supportted ES Modules
module.exports.APP_LAYOUT_TYPES = {
  LOGIN_LAYOUT: "login-layout",
  SIGNUP_LAYOUT: "signup-layout",
  ERROR_LAYOUT: "error-layout",
  SHARING_LAYOUT: "sharing-layout",
  DASHBOARD_LAYOUT: "dashboard-layout",
  TEMPLATE_PREVIEW_LAYOUT: "template-preview-layout",
};
